import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { theme } from '@blueprint/ui';

export type SSRMediaQueryProps = {
    breakpoint?: keyof typeof theme.mediaQueries;
    additionalCondition: boolean;
    invert?: boolean;
};

export const SSRMediaQueryStyle = styled('div')<SSRMediaQueryProps>(
    ({ additionalCondition, breakpoint, invert, theme }) => css`
        display: block;

        ${!additionalCondition && `display: none;`}

        ${breakpoint &&
        `
            ${theme.mediaQueries[breakpoint]} {
                display: none;
            }
        `}

        ${invert &&
        breakpoint &&
        `
            ${theme.mediaQueries[breakpoint]} {
                display: block;
            }
        `}
    `
);
